import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { zIndexes } from "../../theme/zIndex";
import { responsive } from "../../utils/responsive";

export const containerStyle = recipe({
  base: {
    pointerEvents: "none",
    position: "fixed",
    zIndex: zIndexes.navigation,
    display: "flex",
    alignItems: "center",
    top: theme.spacings.s,
    right: "50%",
    transform: "translateX(50%)",
    ...responsive({
      s: {
        right: theme.spacings.s,
        transform: "none",
      },
    }),
  },
});

export const navigationStyle = recipe({
  base: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    gap: theme.spacings.xs,
    pointerEvents: "auto",
    background: theme.colors.navigation,
    borderRadius: "999px",
    padding: `${theme.spacings.xs} ${theme.spacings.xs}`,
  },
});

export const rulerStyle = style({
  height: "1px",
  width: theme.spacings.l,
  background: theme.colors.defaultBorder,
  margin: `${theme.spacings.xxs} 0`,
});
